export default __webpack_public_path__ + "static/media/earrings_2.3284570d.webp";